import * as MUI from "@mui/material";
import SectionLabel from "./SectionLabel";

export default function SectionCard({ label, children }) {
  return (
    <MUI.Paper
      variant="outlined"
      sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 3, borderColor: "divider" }}
    >
      <SectionLabel>{label}</SectionLabel>
      <MUI.Box sx={{ mt: 1.75 }}>{children}</MUI.Box>
    </MUI.Paper>
  );
}
